import { getDeviceId } from "utils/localStorage";

const deviceContext = {
  kind: "device",
  key: getDeviceId(),
  userAgent: navigator.userAgent.split(" ")
};

const userContext = {
  kind: "user",
  anonymous: true
};

const multiContext = {
  kind: "multi",
  user: userContext,
  device: deviceContext
};
export const resolveLaunchDarklyContext = ({
  userEmail,
  userId,
  isGuestUser
}) => {
  let ctx = multiContext;
  if (userId && !isGuestUser) {
    ctx = {
      ...multiContext,
      user: {
        kind: "user",
        key: userId,
        email: userEmail
      }
    };
  }
  return ctx;
};
